// WIP - started but not finished.
import * as ChoiceUtils from '../lib/ChoiceUtils'
import { DisplayStyle, ToastDisplayStyles } from '../Enums/UiEnums';


export class ToastItem {
    readonly id = `toast_${ChoiceUtils.randomId()}`;
    readonly title?: string;
    readonly msgHtml?: string;
    readonly hideDelayMilliseconds?: number;
    show: boolean = true;
    displayStyle: ToastDisplayStyles = DisplayStyle.Info;
    showActionLink?: boolean;
    actionLinkText?: string; 
    data?: any;     // Passed when we have an action to clarify what we want done

    public constructor(
        title: string | undefined,
        msgHtml: string|undefined,
        displayStyle: ToastDisplayStyles = DisplayStyle.Info,
        showActionLink: boolean = false,
        hideDelayMilliseconds?: number,
        actionLinkText?: string,
        data?: any 
    ){
        this.title = title;
        this.msgHtml = msgHtml;
        this.showActionLink = showActionLink;
        this.displayStyle = displayStyle;
        this.hideDelayMilliseconds = hideDelayMilliseconds;
        this.actionLinkText = actionLinkText; 
        this.data = data;
    }
}